import { usePageMeta } from "@/hooks/usePageMeta";
import { FAQS } from "@/lib/constants";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

export default function FAQs() {
  usePageMeta("FAQs", "Frequently asked questions about ordering from Nicee.");
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
      <div className="text-center">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand/10 text-brand">
          <HelpCircle className="h-6 w-6" />
        </span>
        <h1 className="mt-4 font-heading text-3xl font-bold text-ink sm:text-4xl">Frequently Asked Questions</h1>
        <p className="mt-2 text-ink-soft">Everything you need to know about ordering with us.</p>
      </div>

      <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="rounded-2xl border border-border/60 bg-white px-5 shadow-ambient">
            <AccordionTrigger className="text-left font-heading text-base text-ink hover:no-underline" data-testid={`faq-q-${i}`}>
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-ink-soft">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
